export function validarCamposPersona({ identidad, telefono }) {
    identidad.addEventListener('input', function () {
        this.value = this.value.replace(/\D/g, '').slice(0, 13);
    });

    telefono.addEventListener('input', function () {
        this.value = this.value.replace(/\D/g, '').slice(0, 8);
    });
}